define('../src/sublayouts/m24-video-gallery/m24-video-gallery',['jquery', 'lib/utils'], function ($, utils) {

	'use strict';

	var VideoCarousel = function ($component) {

		this.$component = $component;

		return this;
	};

	VideoCarousel.prototype.init = function () {
		var _this = this,
			playlistId = this.$component.data('playlist');
			
		_this.createPlaylist(playlistId);
		$('.m24-video-gallery--playlistToggle').on('click', function () {
			$(this).toggleClass('icon-open');
			$(this).toggleClass('icon-close');
			$('.m24-video-gallery--playlist').toggleClass('m24-video-gallery--playlist_active');
		});

		$(window).on('m24.init',function(){
			_this.init()
		})
	};

	VideoCarousel.prototype.createPlaylist = function (id) {
		var _this = this;
		$.ajax({
			url: 'https://www.googleapis.com/youtube/v3/playlistItems',
			type: 'get',
			dataType: 'json',
			data: {
				part: "snippet , contentDetails",
				playlistId: id,
				maxResults: 50,
				key: 'AIzaSyC-3Nxf76b84INqZYanzREWkVL5KmNvHRQ'
			},
			success: function (data) {
				_this.getVideoId(data)
			}
		});
	};

	VideoCarousel.prototype.getVideoId = function (data) {
		var _this = this,
			ids = "",
			itemsNum = 0;
		$.each(data.items, function () {
			itemsNum++
			if (itemsNum == data.items.length) {
				ids = ids + this.contentDetails.videoId
				_this.getVideoDetails(ids)
			} else {
				ids = ids + this.contentDetails.videoId + ","
			}
		})
	}

	VideoCarousel.prototype.getVideoDetails = function (ids) {
		var _this = this;
		$.ajax({
			url: 'https://www.googleapis.com/youtube/v3/videos',
			type: 'get',
			dataType: 'json',
			data: {
				part: 'contentDetails,snippet',
				id: ids,
				key: 'AIzaSyC-3Nxf76b84INqZYanzREWkVL5KmNvHRQ'
			},
			success: function (data) {
				_this.createJson(data)
			}
		});
	};

	VideoCarousel.prototype.createJson = function (data) {
		var _this = this,
			jsonData = [];
		$.each(data.items, function (index) {
			var date = _this.dopFormat(data.items[index].snippet.publishedAt),
				time = _this.timeFormat(data.items[index].contentDetails.duration),
				obj = {
					"id": data.items[index].id,
					"img": data.items[index].snippet.thumbnails.high.url,
					"title": data.items[index].snippet.title,
					"DoP": date,
					"len": time
				}
			jsonData.push(obj)
		})
		_this.initGallery(jsonData)
	}

	VideoCarousel.prototype.timeFormat = function (time) {
		var string = time,
			array = string.match(/(\d+)(?=[MHS])/ig) || [];
		var formatted = array.map(function (item) {
			if (array.length == 1) return '00:' + item;
			if (item.length < 2) return '0' + item;
			return item;
		}).join(':');
		return formatted
	}

	VideoCarousel.prototype.dopFormat = function (date) {
		var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			d = new Date(date),
			month = monthNames[d.getMonth() + 1],
			day = d.getDate(),
			year = d.getFullYear(),
			dop = '' + day + ' ' + month + ' ' + year;
		return dop
	}


	VideoCarousel.prototype.initGallery = function (data) {
		var _this = this,
			$list = this.$component.find('.m24-video-gallery--playlist'),
			modalTrigger = this.$component.find('.m18-modal__trigger'),
			$navTriggerNext = this.$component.find('.m18-modal__button-next'),
			$navTriggerPrev = this.$component.find('.m18-modal__button-prev'),
			i = 0;
			$list.empty()

		$.each(data,function () {
			var $time;
			$list.append('<div class="m24-video-gallery-item m20-teaser-card item-col-l-4 item-col-m-3" data-index=' + i + ' data-id="' + this.id + '"><div class="m20-teaser-card--main"><div class="m20-teaser-img"><img alt="' + this.title + '" class="m24-video-gallery--playlist_thumb" src="' + this.img + '"><span class="m20-teaser-subtitle">' + this.len + '</span></div><div class="m20-teaser-content"><div class="m20-teaser-title">' + this.title + '</div><div class="m20-teaser-subtitle">' + this.DoP + '</div></div></div></div>');
			i++
		});

		$('.m24-video-gallery-item').each(function () {
			var $item = $(this);

			$item.on('click', function () {
				modalTrigger.trigger('click')
				if (!$item.hasClass('m20-teaser-card--active')) {
					$('.m20-teaser-card').each(function () {
						$(this).removeClass('icon-play m20-teaser-card--active');
					});
					_this.loadVideo(data[$item.attr('data-index')],$item.attr('data-index'));
					$item.addClass('icon-play m20-teaser-card--active');
				};
			});
		});
		$(document).on('keydown', function(e) {
			if($('.m18-modal--video-gallery .m18-modal__container').hasClass('m18-modal__container--active')){
				if(e.keyCode == 37) {
					_this.prevVideo($list,data)
				}
				if(e.keyCode == 39) {
					_this.nextVideo($list,data)
				}
			}
		});

		$navTriggerNext.on('click',function(){
			_this.nextVideo($list,data)
		})

		$navTriggerPrev.on('click',function(){
			_this.prevVideo($list,data)
		})
	};

	VideoCarousel.prototype.nextVideo = function($list,data){
		var _this = this,
			$activeItem = $list.find('.m20-teaser-card--active'),
			activeItemIntex = $activeItem.data('index'),
			totalIndex = data.length - 1,
			//preItemIndex = activeItemIntex == 0 ? totalIndex : activeItemIntex - 1,
			nextItemIndex = activeItemIntex == totalIndex ? 0 : activeItemIntex + 1;
			
			$activeItem.removeClass('icon-play m20-teaser-card--active');
			$list.find('[data-index='+nextItemIndex+']').addClass('icon-play m20-teaser-card--active');
			_this.loadVideo(data[nextItemIndex],nextItemIndex);
	}

	VideoCarousel.prototype.prevVideo = function($list,data){
		var _this = this,
			$activeItem = $list.find('.m20-teaser-card--active'),
			activeItemIntex = $activeItem.data('index'),
			totalIndex = data.length - 1,
			preItemIndex = activeItemIntex == 0 ? totalIndex : activeItemIntex - 1;
			//nextItemIndex = activeItemIntex == totalIndex ? 0 : activeItemIntex + 1;
		
			$activeItem.removeClass('icon-play m20-teaser-card--active')
			$list.find('[data-index='+preItemIndex+']').addClass('icon-play m20-teaser-card--active')
			_this.loadVideo(data[preItemIndex],preItemIndex);
	}

	VideoCarousel.prototype.loadVideo = function (data,num) {
		var _this = this,
			$container = this.$component.find('.m24-video-gallery--player'),
			$title = this.$component.find('.m24-video-gallery--playertitle'),
			$pub = this.$component.find('.m24-video-gallery--playerpub'),
			$len = this.$component.find('.m24-video-gallery--playerlen');

		$container.find('.m24-video-gallery__videoplayer--inner').attr('src', 'https://www.youtube.com/embed/' + data.id + '?autoplay=1&showinfo=0&rel=0&modestbranding=1');
		$container.find('.m24-video-gallery__videoplayer--inner').attr('title', data.title);
		$title.html(data.title);
		$pub.find('span').html(data.DoP);
		$len.find('span').html(data.len);
		$container.data('index',num)
		$container.attr('data-index',num)
	};

	return VideoCarousel;
});

